(function ($) {
    $.fn.Datalist = function () {
        this.each(function(){
            var inputId = $(this).attr('id');
            var $input = $('#'+inputId);

            var datalistId = $input.attr('list');
            var $datalist = $('#'+datalistId)
            var options = $datalist.find('option').map(function () {
                return this.value;
            }).get();
            $datalist.remove();

            var $options = $('<ul>', {
                'class' : 'datalist-options d-none list-group-flush border border-top-0 p-0',
                'id' : inputId+'_options',
                'html' : $('<li>', {
                    'class' : 'datalist-no-options list-group-item px-1 py-0 font-italic text-gray d-none',
                    'html' : 'Aucun élément correspondant'
                })
            });
            options.forEach(
                (element) => {
                    var $option = $('<li>',{
                        'class' : 'datalist-option list-group-item px-1 py-0',
                        'html' : element,
                    });
                    $option.click((e) => {
                        $input.val($(e.currentTarget).html());
                        $input.change();
                    }).mouseenter((e) => {
                        $(e.currentTarget).siblings().removeClass('selected');
                        $(e.currentTarget).addClass('selected');
                    })
                    $options.append($option);
                }
            );
            $options.insertAfter($input);

            $input.focus(() => {
            }).blur(() => {
                setTimeout(function(){
                    $options.addClass('d-none');
                }, 100);
            }).on('focus keyup', (e) => {
                $options.removeClass('d-none');
                $options.css('min-width', $input.css('width'));
                let inputValue = $(e.currentTarget).val();
                let noOptions = false;
                $('#'+inputId+'_options > .datalist-option').each((index, element) => {
                    if ($(element).html().toLowerCase().indexOf(inputValue.toLowerCase()) >= 0){
                        $(element).removeClass('d-none');
                        noOptions = true;
                    } else {
                        $(element).addClass('d-none').removeClass('selected');
                    }
                });
                if (noOptions) {
                    $('#'+inputId+'_options > .datalist-no-options').addClass('d-none');
                } else {
                    $('#'+inputId+'_options > .datalist-no-options').removeClass('d-none');
                }
            }).keydown((e) => {
                let $selected = $('#'+inputId+'_options > .datalist-option.selected');
                switch (e.which){
                    case 38 : //up
                        e.preventDefault();
                        if ($selected.length === 0 ) {
                            $('#'+inputId+'_options > .datalist-option:not(.d-none):eq(0)').addClass('selected');
                        } else {
                            let $prev = $selected.prevAll(':not(.d-none):eq(0)')
                            if ($prev.length > 0){
                                $selected.removeClass('selected');
                                $prev.addClass('selected');
                                if ($prev.position().top < 0){
                                    $options.scrollTop($options.scrollTop() - ($options.height()) + ($prev.height() + $prev.position().top));
                                }
                            }
                        }
                        break;
                    case 40 : //down
                        e.preventDefault();
                        if ($selected.length === 0 ){
                            $('#'+inputId+'_options > .datalist-option:not(.d-none):eq(0)').addClass('selected');
                        } else {
                            let $next = $selected.nextAll(':not(.d-none):eq(0)');
                            if ($next.length > 0){
                                $selected.removeClass('selected');
                                $next.addClass('selected');
                                if ($next.position().top + $next.height() > $options.height()){
                                    $options.scrollTop($options.scrollTop() + $next.position().top);
                                }
                            }
                        }
                        break;
                    case 13 : //enter
                        e.preventDefault();
                        $selected.click();
                        break;
                }
            });
        });
    }
}(jQuery));


// WEBPACK FOOTER //
// ./assets/js/datalist.js